<div class="container">
  @if (isPaired()) {
  <h6>{{ 'home.yourProducts' | translate }}</h6>
  } @else {
  <h6>
    {{ 'home.connectProducts' | translate: { actabl: 'Actabl' } }}
  </h6>
  }
  <div class="row">
    @for (product of products(); track product) {
    <app-product-card
      [product]="product"
      [isPaired]="isPaired()"
    ></app-product-card>
    }
  </div>
</div>
